import React from "react";
import "../App.css";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { db } from "../firebase";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { setLoggedOut } from "../Actions";
import { connect } from "react-redux";

function Menus(props) {
  const navigate = useNavigate();

  const logout = async () => {
    const uid = localStorage.getItem("user_id");
    if (uid) {
      await updateDoc(doc(db, 'presence', uid), { online: false, last_seen: serverTimestamp() });
    }
    await signOut(auth);
    localStorage.removeItem("user_id");
    props.setLoggedOut();
    props.setMenuOpen(false);
    navigate("/");
  };

  const handleLinkClick = () => {
    props.setMenuOpen(false);
  };

  if (!props.loggedIn) {
    return (
      <nav>
        <ul>
          <li><Link to="/">About</Link></li>
          <li><Link to="/read">Read</Link></li>
          <li><Link to="/login">Login</Link></li>
          <li><Link to="/register">Register</Link></li>
        </ul>
      </nav>
    );
  }

  return (
    <>
      <div
        className={`sidebar-overlay${props.menuOpen ? " open" : ""}`}
        onClick={() => props.setMenuOpen(false)}
      />
      <div className={`sidebar${props.menuOpen ? " open" : ""}`}>
        <button
          className="sidebar-close"
          onClick={() => props.setMenuOpen(false)}
          aria-label="Close menu"
        >
          ×
        </button>
        <nav>
          <ul>
            <li><Link to="/read" onClick={handleLinkClick}>Study</Link></li>
            <li><Link to="/dashboard" onClick={handleLinkClick}>Dashboard</Link></li>
            <li><Link to="/profile" onClick={handleLinkClick}>My Profile</Link></li>
            <li><Link to="/users" onClick={handleLinkClick}>The Community</Link></li>
            <li><Link to="/theforum" onClick={handleLinkClick}>The Forum</Link></li>
            <li><Link to="/videos" onClick={handleLinkClick}>Video Teachings</Link></li>
            <li><Link to="/soulcare" onClick={handleLinkClick}>Soul Care</Link></li>
            <li><Link to="/groups" onClick={handleLinkClick}>Groups</Link></li>
            <li><Link to="/whosonline" onClick={handleLinkClick} style={{ color: '#FFF0C0' }}>Who's Online</Link></li>
            <li>
              <Link to="/" onClick={logout}>Logout</Link>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    first_name: state.first_name,
    last_name: state.last_name,
    loggedIn: state.loggedIn,
  };
};

export default connect(mapStateToProps, { setLoggedOut })(Menus);
